import multiRequest from '../shared/multiRequest';

function getData() {
  return multiRequest([
    {
      url: 'marketplace/bundles/extra-balance',
      method: 'GET',
    },
  ]);
}

function purchase(extraBalanceCode) {
  return multiRequest([
    {
      url: 'marketplace/bundles/extra-balance/purchase',
      method: 'POST',
      data: {
        code: extraBalanceCode,
      },
    },
  ]);
}

const ExtraBalanceService = {
  getData,
  purchase,
};

export default ExtraBalanceService;
